/**
 * messaging API — generated from HAR captures.
 * Regenerate: npm run api:from-har
 */
import { apihubRootPost } from "./apihub";
import { buildPath, withQuery } from "./paths";

/** POST `/send-testmessage` */
export function postSendTestmessage(payload = {}) {
  return apihubRootPost('/send-testmessage', payload);
}

/** POST `/send-textonly` */
export function postSendTextonly(payload = {}) {
  return apihubRootPost('/send-textonly', payload);
}
